var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.49C1 11.063 11.08 1 23.51 1 35.937 1 46 11.062 46.018 23.49 46.019 35.957 35.938 46 23.435 46 11.044 45.981 1 35.9 1 23.49Z",
    fill: "#355E9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67 37.354c-.074-.093 0-.168.02-.242l3.074-10.398c.019-.074.037-.167.075-.298-1.193.354-2.367.708-3.522 1.062-.037-.112.018-.167.037-.242.205-.69.429-1.398.634-2.087.037-.149.111-.224.279-.28 1.043-.316 2.087-.633 3.15-.95.185-.056.26-.149.316-.317 1.472-4.993 2.963-9.987 4.435-15 .149-.521.428-.726.969-.726h4.602c.596 0 .876.372.708.931-1.23 4.193-2.46 8.404-3.708 12.597-.018.074-.056.13-.037.242 1.174-.354 2.329-.708 3.54-1.08-.056.223-.112.39-.168.577-.167.596-.354 1.192-.521 1.789-.056.186-.13.26-.317.317-1.062.298-2.124.614-3.205.931-.112.037-.186.093-.224.205-.745 2.516-1.49 5.05-2.236 7.565-.018.056-.018.094-.037.15.093.037.187.018.28.018H33.87c.67 0 .931.354.745.988-.336 1.136-.67 2.254-.988 3.39-.13.467-.372.746-.838.84-.075.055-.15.018-.224.018h-18.69c-.055.019-.13.056-.204 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.c940d88aa701e9489d9c474e735d98fd.svg";
export { ForwardRef as ReactComponent };